export default __webpack_public_path__ + "static/media/bookmark3.ac146a39.png";